import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const IconContainer = styled.div<{ size?: string }>`
  padding-right: ${Variables.space75};
  ${({ size }) => (size ? `width: ${size}; height: ${size};` : "")}
`;
